import React, { useState, useEffect } from "react";
import "./HomePage.css";

const HomePage = () => {
  const [opacity, setOpacity] = useState(1);

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const newOpacity = Math.max(1 - scrollY / 100);
    setOpacity(newOpacity);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="homepage-div">
      <div className="background-image"></div>

      <div className="background">
        <div className="container-home">
          <div>
            <div
              style={{ opacity: opacity }}
              className="centered-text"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              SBHM
            </div>
          </div>
          <div
            style={{ opacity: opacity }}
            className="concept"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            concept
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
